<ng-template #modalContent let-modal>
  <div class="modal-header">
    <h4 class="modal-title me-auto">Add Person to Payroll</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss(true)"
      cpGTagEvent
      [params]="{ event_label: 'payroll_add_person_modal_dismiss' }">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div id="add-person-autocomplete" class="ng-autocomplete">
      <ng-autocomplete
        [data]="data"
        [searchKeyword]="keyword"
        placeholder="Type Person's Name..."
        (selected)="selectEvent($event)"
        (inputChanged)="onChangeSearch($event)"
        [itemTemplate]="query && query.length >= 2 ? itemTemplate : null"
        [notFoundTemplate]="query && query.length >= 2 ? notFoundTemplate : null">
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.Value"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
        <small>No records found...</small>
      </ng-template>
    </div>
    <div class="mt-3">
      <small>
        Can't find who you are looking for?
        <a class="cp-green" (click)="addNewPerson(modal)"> Click here to add a new person. </a>
      </small>
    </div>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="modal.dismiss(true)"
      cpGTagEvent
      [params]="{ event_label: 'payroll_add_person_modal_cancel' }">
      Cancel
    </button>
    <button
      type="button"
      class="btn btn-primary"
      (click)="modal.close()"
      [disabled]="disableSave"
      cpGTagEvent
      [params]="{ event_label: 'payroll_add_person_modal_save' }">
      {{ saveText }}
    </button>
  </div>
</ng-template>
